module.exports = __webpack_public_path__ + "img/6.7035a974.png";